import React, { Component } from 'react';
import Header from './../common/Header';
import { Button, Card } from 'reactstrap';
import { connect } from 'react-redux';
import ReactLoading from 'react-loading';
import { articleTextChange, addArticle, fetchLoading, incrementCounter, clearCounter } from '../../actions/Articles/ArticleAction';

class AddArticles extends Component {
    
    componentWillMount() {
        this.props.fetchLoading();
        this.props.clearCounter();
    }

    onArticleTextChange(event) {
        this.props.articleTextChange(event);
    }

    render() {
        const { users, articleText, loading, counter } = this.props;
        return (
            <div>
                <Header />
                <div style={{ padding: 30, width: '100%', paddingTop: 40 }}>
                    <Card style={styles.cardStyle}>
                        <h6 style={{ fontFamily: "Source Sans Pro-SemiBold", paddingBottom: 10 }}>Enter the Article Link</h6>
                        <textarea
                             style={styles.textAreaStyle}
                             value={this.props.articleText}
                             onChange={event => this.onArticleTextChange(event.target.value)}
                        />
                        <div style={{ paddingTop: 20 }}>
                            {
                                counter === 0 ?
                                    <div>
                                        {
                                            this.props.articleText.length === 0 ?
                                            <button type="button" className="btn btn-default" disabled="disabled">
                                                Submit
                                            </button> :
                                                <Button
                                                    style={styles.buttonStyle}
                                                    onClick={() => {
                                                             this.props.addArticle(users, articleText);
                                                             this.props.incrementCounter(counter);
                                                    }}
                                                >
                                                    Submit
                                                </Button>
                                        }
                                    </div>
                                     :
                                    <button type="button" className="btn btn-default" disabled="disabled">
                                        Submit
                                    </button>
                            }
                        </div>
                        <div style={{ paddingTop: 10 }}>
                            {
                                loading === true ?
                                    <div style={styles.loadingStyle}>
                                        <ReactLoading type="spinningBubbles" color="#40b508" height={50} width={50} />
                                    </div>
                                    : null
                            }
                        </div>
                    </Card>
                </div>
            </div>
        );
    }
}

const styles = {
    inputStyle: {
        width: '70%',
        height: 40,
        paddingLeft: 20,
        borderRadius: '4px',
        borderColor: '#9b9b9b',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0,
        borderWidth: '0.5px'
    },
    textAreaStyle: {
        width: '70%',
        height: 75,
        paddingLeft: 20,
        borderRadius: '4px',
        borderColor: '#9b9b9b',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0
    },
    cardStyle: {
        borderColor: '#7ed321',
        alignItems: 'center',
        padding: 30,
        width: '50%',
        margin: 'auto',
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`,
        borderRadius: 10
    },
    buttonStyle: {
        fontFamily: "Source Sans Pro-SemiBold",
        backgroundColor: '#40b508',
        borderWidth: 0,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    },
     loadingStyle: {
         display: 'flex',
         width: '100%',
         height: 100,
         alignItems: 'center',
         justifyContent: 'center'
     }
};

function mapStateToProps(state) {
    return {
        users: state.login.user,
        articleText: state.article.articleText,
        articleData: state.article.newArticle,
        loading: state.article.loading,
        counter: state.article.counter
    };
}

export default connect(mapStateToProps, { articleTextChange, addArticle, fetchLoading, incrementCounter, clearCounter })(AddArticles);



// WEBPACK FOOTER //
// ./src/components/Articles/AddArticles.js